import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';

export interface ProfitabilityCourierServiceOption {
  value: string;
  label: string;
}

/**
 * Todos los servicios de mensajería (courier_services activos) para selects de rentabilidad.
 */
export const useProfitabilityCourierServiceOptions = () => {
  const httpClient = createHttpClient(apiClientWH);

  return useQuery<ProfitabilityCourierServiceOption[]>({
    queryKey: ['profitability', 'courier-service-options'],
    queryFn: async () => {
      const raw = await httpClient.get<any>('/couriers');
      const couriers = Array.isArray(raw) ? raw : (raw.data ?? []);
      const batches = await Promise.all(
        couriers.map(async (c: { id: number; name: string }) => {
          try {
            const sraw = await httpClient.get<any>(`/couriers/${c.id}/services`, {});
            const services = Array.isArray(sraw) ? sraw : (sraw.data ?? []);
            return services
              .filter((s: { deleted_at?: string | null }) => s.deleted_at == null)
              .map((s: { id: number; description?: string; code?: string }) => ({
                value: String(s.id),
                label: `${c.name} — ${s.description || s.code || `#${s.id}`}`,
              }));
          } catch {
            return [];
          }
        })
      );
      const flat = batches.flat();
      flat.sort((a, b) => a.label.localeCompare(b.label));
      return flat;
    },
    staleTime: 10 * 60 * 1000,
  });
};
